import { render, staticRenderFns } from "./SystemMail.vue?vue&type=template&id=20fe2a8e&"
import script from "./SystemMail.vue?vue&type=script&lang=js&"
export * from "./SystemMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports